import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';

@AcDialog({
  width: 400,
})
@Component({
  selector: 'routing-groups-dialog',
  templateUrl: './routing-groups-dialog.component.html',
  styleUrls: ['./routing-groups-dialog.component.scss']
})
export class RoutingGroupsDialogComponent implements OnInit, AfterViewInit {
  data;
  conf;
  @ViewChild('mapForm') mapForm: NgForm;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.data = dialogConfig.dialogData;
    this.conf = dialogConfig;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.conf.submitButtonDisabled = !this.mapForm.form.valid;
    });
  }
}
